<c-auto-form config="autoFormConfig"></c-auto-form>